import React, { useState } from "react";
import { RoleMain } from "./Roles/RoleMain";
import Tab, { TabItem } from "./SettingTabs/Tabs";
import roleIcon from "../../assets/images/tabs/role.png";
import permissionIcon from "../../assets/images/tabs/permission.png";
import delegateIcon from "../../assets/images/tabs/delegate.png";
import managementIcon from "../../assets/images/tabs/management.png";
import appIcon from "../../assets/images/tabs/app.png";
import "./SettingTabs/settingstyle.css";
import { PermissionMain } from "./Permissions/PermissionMain";
import { ManagementMain } from "./Management/ManagementMain";

export const SettingDashboard = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index) => {
    console.log(index);
    setSelectedIndex(index);
  };

  return (
    <div>
      <div className="profileMain">
        <h1 className="MainProfileHeading">Settings</h1>
        <Tab onTabSelected={onTabSelected}>
          <TabItem>
            <img
              className={`${
                selectedIndex === 0 ? "imgStyle imgColor" : "imgStyle"
              }`}
              src={roleIcon}
            ></img>
            Role
          </TabItem>
          <TabItem>
            <img  className={`${
                selectedIndex === 1 ? "imgStyle imgColor" : "imgStyle"
              }`} src={permissionIcon}></img>Permission
          </TabItem>
          <TabItem>
            <img  className={`${
                selectedIndex === 2 ? "imgStyle imgColor" : "imgStyle"
              }`} src={managementIcon}></img>Management
          </TabItem>
          <TabItem>
            <img  className={`${
                selectedIndex === 3 ? "imgStyle imgColor" : "imgStyle"
              }`} src={delegateIcon}></img>Delegate Access
          </TabItem>
          <TabItem>
            <img  className={`${
                selectedIndex === 4 ? "imgStyle imgColor" : "imgStyle"
              }`} src={appIcon}></img>App Suite
          </TabItem>
        </Tab>
        {selectedIndex === 0 && <RoleMain />}
        {selectedIndex === 1 && <PermissionMain index={1} />}
        {selectedIndex === 2 && <ManagementMain />}
      </div>
    </div>
  );
};
